import { createAnonAxios, ensureAnonSession as _ensureAnonSession } from "./vg2AnonAxios";
import { getEffectiveRef } from "./refTracker";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_V2 = `${BACKEND_URL}/api/v2`;

const LS_ANON = "vg2_anon_token";
const LS_JOURNEY = "vg2_journey_id";

const api = createAnonAxios(API_V2);

export async function ensureAnonSession() {
  return _ensureAnonSession(API_V2);
}

export async function getCapisciConfig() {
  const { data } = await api.get("/journeys/capisci/config");
  return data;
}

export function getStoredJourneyId() {
  return localStorage.getItem(LS_JOURNEY);
}

export function saveJourneyId(id) {
  if (id) localStorage.setItem(LS_JOURNEY, id);
}

export function clearJourneyId() {
  localStorage.removeItem(LS_JOURNEY);
}

export async function startJourney() {
  await ensureAnonSession();
  const { data } = await api.post("/journeys/capisci/start", { referral_code_origine: getEffectiveRef() });
  saveJourneyId(data.journey_id);
  return data;
}

export async function getJourney(journeyId) {
  await ensureAnonSession();
  const { data } = await api.get(`/journeys/${journeyId}`);
  return data;
}

export async function patchAnswer(journeyId, questionId, value) {
  const { data } = await api.patch(`/journeys/${journeyId}/answer`, {
    question_id: questionId, value,
  });
  return data;
}

export async function completeJourney(journeyId, operationId) {
  const { data } = await api.post(`/journeys/${journeyId}/complete`,
    operationId ? { operation_id: operationId } : {});
  return data;
}

export async function resetJourney(journeyId) {
  const { data } = await api.post(`/journeys/${journeyId}/reset`, {});
  saveJourneyId(data.journey_id);
  return data;
}

export async function valutaHandoff(journeyId) {
  const { data } = await api.post(`/journeys/${journeyId}/valuta-handoff`, {});
  return data;
}


export async function sendCapisciEmail(journeyId, operationId) {
  const { data } = await api.post(
    `/journeys/${journeyId}/send-capisci-email`,
    operationId ? { operation_id: operationId } : {});
  return data;
}
